import type { TableCellContext } from 'components/Table/model/TableCellContext';

export const deviceExplorerTableCellContext: Partial<TableCellContext> = {
  disableLinks: true,
};
